import axios from "axios";
import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";
const fileUrl = "report/api/v1/";

export default {
  // ReportInfo Actions ------------------------------------------------------------------
  getPrint({ dispatch, commit }, data) {
    axios
      .get(fileUrl + "Print?id=" + data)
      .then((res) => {
        commit("setPrint", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReportInfoLog({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(fileUrl + "ReportInfoLog", data)
      .then((res) => {
        commit("setReportInfoLog", res.data.data);
        dispatch(
          "successPOSTHandlerSilent",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getReportInfo({ dispatch, commit }, data) {
    axios
      .get(fileUrl + "ReportInfo?key=" + data)
      .then((res) => {
        commit("setReportInfo", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getReportInfoDropDown({ dispatch, commit }, data) {
    axios
      .get(fileUrl + "ReportInfo/DropDown/" + data)
      .then((res) => {
        commit("setReportInfoDropDown", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addReportInfoBranch({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post(fileUrl + "ReportInfoBranch", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.save,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
};
